import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { Page404Component } from './page404/page404.component';
import { SchoolComponent } from './school/school.component';
import { GoalComponent } from './goal/goal.component';
import { AuthGuard } from './guards/auth.guard';
import { InterventionsComponent } from './interventions/interventions.component';
import { UsersComponent } from './users/users.component';
import { AcademicsComponent } from './academics/academics.component';
import { CatholicIdentityComponent } from './catholic-identity/catholic-identity.component';
import { EnrollmentComponent } from './enrollment/enrollment.component';
import { EssentialsComponent } from './essentials/essentials.component';
import { AdminComponent } from './admin/admin.component';
import { UploadDataComponent } from './upload-data/upload-data.component';
import { ActionPlanningSnapshotComponent } from './action-planning-snapshot/action-planning-snapshot.component';

const routes: Routes = [
  { 'path': '', component: LoginComponent },
  { 'path': 'login', component: LoginComponent },
  { 'path': 'academics', component: AcademicsComponent },
  { 'path': 'catholic', component: CatholicIdentityComponent },
  { 'path': 'enrollment', component: EnrollmentComponent },
  { 'path': 'essentials', component: EssentialsComponent },
  { 'path': 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { 'path': 'school', component: SchoolComponent, canActivate: [AuthGuard] },
  { 'path': 'planning', component: GoalComponent, canActivate: [AuthGuard] },
  { 'path': 'interventions', component: InterventionsComponent, canActivate: [AuthGuard] },
  { 'path': 'users', component: UsersComponent, canActivate: [AuthGuard] },
  { 'path': 'admin', component: AdminComponent, canActivate: [AuthGuard] },
  { 'path': 'uploadData', component: UploadDataComponent, canActivate: [AuthGuard] },
  { 'path': 'snapshot/:data/:filter', component: ActionPlanningSnapshotComponent, canActivate: [AuthGuard] },
  { 'path': '**', component: Page404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
